import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/common.css';

function ChildLogin() {
  const [formData, setFormData] = useState({
    name: '',
    pin: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/api/v0/auth/child/login', formData);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // 자녀 대시보드로 리다이렉트
      navigate('/child/dashboard');
    } catch (error) {
      setError(error.response?.data?.error || '로그인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <h1 className="title">🧒 자녀 로그인</h1>
      <p className="subtitle">오늘의 미션을 확인해보세요!</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">이름</label>
          <input
            type="text"
            name="name"
            className="form-input"
            value={formData.name}
            onChange={handleInputChange}
            required
            placeholder="김철수"
            data-testid="name-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">PIN</label>
          <input
            type="password"
            name="pin"
            className="form-input"
            value={formData.pin}
            onChange={handleInputChange}
            required
            pattern="[0-9]{1,6}"
            placeholder="123456"
            data-testid="pin-input"
          />
          <small style={{ color: '#666', fontSize: '0.8rem' }}>
            부모님이 설정해준 숫자를 입력해주세요
          </small>
        </div>

        {error && <div className="error" data-testid="error-message">{error}</div>}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%', marginTop: '20px' }}
          data-testid="login-btn"
        >
          {loading ? '로그인 중...' : '로그인'}
        </button>
      </form>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <p style={{ color: '#666', fontSize: '0.9rem', margin: '10px 0' }}>
          PIN을 모르겠나요? 부모님께 물어보세요! 👨‍👩‍👧‍👦
        </p>
      </div>

      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <Link to="/" className="back-btn">
          ← 홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
}

export default ChildLogin;